export const breakpoints = {
	small: 500,
	medium: 760,
	large: 960,
	grid: 1160
}
